// Edit state for the Declined/Cancelled Legs card: keyed by dispatch_recno (a pro
// can have several declined legs). Only ticked rows are sent to the server.
export type DeclinedLegEdit = { resolve: boolean; comment: string };
export type DeclinedLegRow = { dispatch_recno: number; pronumber: number | string };

export const EMPTY_EDIT: DeclinedLegEdit = { resolve: false, comment: '' };

export function applyDeclinedBulkEdit(
  prev: Record<string, DeclinedLegEdit>,
  columnId: string,
  rows: DeclinedLegRow[],
  value: unknown,
): Record<string, DeclinedLegEdit> {
  const next = { ...prev };
  for (const row of rows) {
    const key = String(row.dispatch_recno);
    const existing = next[key] ?? EMPTY_EDIT;
    if (columnId === 'resolve') next[key] = { ...existing, resolve: Boolean(value) };
    else if (columnId === 'resolve_comment') next[key] = { ...existing, comment: String(value ?? '') };
  }
  return next;
}

/** Rows to POST: ticked edits that still exist in the card's data. */
export function declinedRowsToSave(
  edits: Record<string, DeclinedLegEdit>,
  data: DeclinedLegRow[],
): { dispatch_recno: number; pronumber: number; comment: string }[] {
  const byRecno = new Map(data.map((r) => [String(r.dispatch_recno), r]));
  return Object.entries(edits)
    .filter(([, e]) => e.resolve)
    .flatMap(([key, e]) => {
      const row = byRecno.get(key);
      return row
        ? [{ dispatch_recno: row.dispatch_recno, pronumber: Number(row.pronumber), comment: e.comment.trim() }]
        : [];
    });
}

/** Drop edits for rows no longer in the card (after refetch). */
export function pruneDeclinedEdits(
  prev: Record<string, DeclinedLegEdit>,
  data: DeclinedLegRow[],
): Record<string, DeclinedLegEdit> {
  const present = new Set(data.map((r) => String(r.dispatch_recno)));
  let changed = false;
  const next: Record<string, DeclinedLegEdit> = {};
  for (const k of Object.keys(prev)) {
    if (present.has(k)) next[k] = prev[k];
    else changed = true;
  }
  return changed ? next : prev;
}
